import { useAuth } from '../auth/AuthProvider.js';

/**
 * Where the sign-in e-mails come from (docs/adr/ADR-004): Identity Platform
 * sends them from its own domain, which spam filters often catch.
 */
export function EmailDeliveryHint() {
  const { config } = useAuth();
  if (config?.mode !== 'firebase') return null;
  return (
    <p className="muted small">
      L’e-mail arriva da <strong>noreply@{config.firebase.authDomain}</strong>. Se non la trovi dopo
      qualche minuto controlla la posta indesiderata; nelle caselle aziendali può finire in
      quarantena, visibile solo a chi amministra la posta.
    </p>
  );
}
